/**
 * @param string webhook - Slack App Webhook URL
 * @param string text - Message to post
 *
 * @return Promise
 */
exports.logSlack = (webhook, text) => {
  return new Promise((resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      header: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text,
      }),
    }

    if (typeof window !== "undefined") {
      fetch(webhook, requestOptions)
        .then((data) => resolve(data))
        .catch(reject)
    } else {
      require('node-fetch')(webhook, requestOptions)
        .then((data) => resolve(data))
        .catch(reject)
    }
  })
}